<template>
    <v-layout align-center justify-center class="upload_bg">

        <!-- GLOBAL APP BAR HEADER -->
        <v-toolbar fixed flat class="transparent white--text">
            <span>Attendance Capture</span>
            <v-spacer></v-spacer>
            <v-toolbar-items>       
                <v-btn dark flat @click="closeDialog">Cancel</v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <!-- GLOBAL ALERTS CONTAINER -->
        <v-alert v-if="error" :value="true" type="error" icon="error" dismissible class="mb-4">
            {{ errorMessage }}
        </v-alert> 
        
        <!-- CONTAINER CONTENT BOX -->
        <v-flex xs12 sm7 :class="isMobile ? 'content-container-mobile' : ''"> 
            <div class="text-xs-center" :class="isMobile ? 'content-container-main-mobile' : ''">
                
                <!-- LIVE CAMERA VIEWFINDER -->
                <div v-show="showCameraScreen" class="camera-frame mb-3">
                    <video autoplay playsinline muted class="video-image"></video>
                </div>

                <!-- CAPTURED SNAPSHOT CANVAS INTERFACE -->
                <div v-show="showImage" class="camera-frame mb-3">
                    <img id="imgAttendancePic" src="" class="video-image"> 
                </div>

            </div>

            <!-- DYNAMIC CONTROL ACTIONS BAR CONTAINER -->
            <div :class="isMobile ? 'img-controls' : 'text-xs-center mt-4'">
                <v-btn dark large @click="takeScreenshot" :loading="loadingScreenshot" v-show="showScreenshot" color="primary" title="Take Picture">
                    <v-icon class="mr-2">linked_camera</v-icon>Take Picture
                </v-btn>
                <v-btn dark large @click="takeAgain" v-show="showSavePic" outline class="mr-2" title="Take Another">
                    <v-icon class="mr-2">refresh</v-icon>Take Again
                </v-btn>
                <v-btn dark large @click="savePicture" :loading="loading" v-show="showSavePic" color="primary" title="Save Attendance Picture">
                    <v-icon class="mr-2">save</v-icon>Save
                </v-btn>
            </div>
        </v-flex>

    </v-layout>
</template>

<script>
export default {
    name: 'TakePicture',
    data () {
        return {
            userId: 0,
            loading: false,   
            img: null,
            video: null,
            videoStream: null,    
            showCameraScreen: false,
            showScreenshot: false,
            showImage: false,
            showSavePic: false,
            loadingScreenshot: false,
            transDate: null,
            action: null,
            error: false,
            errorMessage: ''
        }
    },
    methods: {
        // --- LIVE HARDWARE STREAM CONTROLS ---
        turnOnVideo(action, transDate) {
            try {
                this.error = false;
                this.errorMessage = '';
                this.transDate = transDate;
                this.action = action;
                
                this.showCameraScreen = true;
                this.showScreenshot = true;
                this.loadingScreenshot = true;
                this.showImage = false;
                this.showSavePic = false;

                const constraints = {
                    video: { width: { exact: 440 }, height: { exact: 360 } }
                };
                this.video = document.querySelector('video');

                navigator.mediaDevices.getUserMedia(constraints)
                    .then((stream) => {                        
                        this.video.srcObject = stream;
                        this.videoStream = stream;
                        this.loadingScreenshot = false;
                    })
                    .catch((err) => {
                        this.loadingScreenshot = false;
                        this.error = true;
                        this.errorMessage = "Could not open camera stream for tracking. Please verify hardware permissions.";
                        this.closeDialog();
                    });
            } catch(error) {
                this.loadingScreenshot = false;
                this.error = true;
                this.errorMessage = error.message || error;
            }
        },
        turnOffDevice() {
            if (this.videoStream !== null) {
                this.videoStream.getTracks().forEach((track) => {
                    track.stop();
                });
                this.videoStream = null;
            }
        },
        takeAgain() {
            this.showImage = false;
            this.showSavePic = false;
            this.turnOffDevice();
            this.turnOnVideo(this.action, this.transDate);
        },

        // --- MATCH VIEWPORT CHANNELS EXACTLY (FREEZE FRAME EFFECT) ---
        async takeScreenshot() {
            try {
                this.showImage = true;
                this.img = document.getElementById('imgAttendancePic');
                
                const canvas = document.createElement('canvas');
                
                // 1. Read the precise native feed width/height from the camera track
                const nativeWidth = this.video.videoWidth;
                const nativeHeight = this.video.videoHeight;
                
                // 2. Map canvas boundaries 1:1 to prevent distortion or clipping
                canvas.width = nativeWidth;
                canvas.height = nativeHeight;
                
                const ctx = canvas.getContext('2d');

                // 3. Draw the full, un-cropped video viewport snapshot
                ctx.drawImage(this.video, 0, 0, nativeWidth, nativeHeight);
            
                // 4. Output image matching original configuration targets
                this.img.src = canvas.toDataURL('image/png');

                this.showCameraScreen = false;
                this.showScreenshot = false;
                this.showSavePic = true;
                this.turnOffDevice();
            } catch (error) {
                this.error = true;
                this.errorMessage = "Failed to capture freeze-frame display snapshot.";
            }
        },
        async savePicture() {
            try {
                this.loading = true;
                this.error = false;
                this.errorMessage = '';

                // Create a clean execution canvas context to convert DOM img element properties safely
                const canvas = document.createElement("canvas");
                canvas.width = this.img.naturalWidth || 1080;
                canvas.height = this.img.naturalHeight || 1080;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(this.img, 0, 0);
                const imageBase64 = canvas.toDataURL("image/png");

                // Emit payload directly upstream back into your clock action method handler
                this.$emit('send', imageBase64);
                this.loading = false;
                this.closeDialog();
            } catch(error) {
                this.loading = false;
                this.error = true;
                this.errorMessage = error.message || error;
            }
        },
        closeDialog() {
            this.turnOffDevice();

            this.showCameraScreen = false;
            this.showScreenshot = false;
            this.showImage = false;
            this.showSavePic = false;
            this.error = false;
            this.errorMessage = '';
            
            this.$emit('update:dialogTakePic', false);   
        }
    },        
    created() {
        this.userId = this.$store.state.userId;
    },
    destroyed() {
        this.turnOffDevice();
    }
}
</script>

<style scoped>
.upload_bg {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: rgba(0, 0, 0, 0.9)
}
.content-container-mobile {
    position: relative !important;
    height: 100% !important;
}
.content-container-main-mobile {
    position: absolute; 
    top: 20%; 
    width: 100%;
}
.camera-frame {
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
.video-image {
    max-width: 100% !important;
    width: auto !important;
    height: auto !important;
    border-radius: 8px !important;
    margin: auto;
}
.img-controls {
    position: absolute; 
    bottom: 5%; 
    left: 50%; 
    transform: translateX(-50%); 
    width: 90%; 
    padding: 10px 10px 20px 10px;
    box-sizing: border-box;
    z-index: 99 !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 10px !important;
}
</style>
